import React from 'react';
import {Card, Empty, Flex} from "antd";
import {EventCard} from "../../home/EventCard";
import {PublicEventDTO} from "../../home/types";
import {useQuery} from "react-query";
import axios, {AxiosResponse} from "axios";
import {launcherCard} from "../common/styles";
import {LoadingIndicator} from "../../commons/Indicators";
import {Heading} from "../../commons/translations/Heading";

export const ActiveEvents = () => {
    const {isLoading: isLoadingEvents, data: events} = useQuery(`upcoming-events`,
        () => axios.get<any,AxiosResponse<PublicEventDTO[]>>(`/api/events` ).then(r => r.data));

    if (isLoadingEvents) {
        return (
            <Card style={{...launcherCard}}>
                <LoadingIndicator />
            </Card>
        );
    }

    return (
        <Card style={{...launcherCard, marginBottom: '20px'}} title={<Heading level={4} trl={'home.stats.active.events.title'}/> }>
            <Flex vertical={true} gap="middle">
                {!events || events.length === 0 && <Empty/>}
                {(events || []).map((event: PublicEventDTO) => (
                    <EventCard key={event.id} event={event} />
                ))}
            </Flex>
        </Card>
    );
};